//LES SERVICES API
export const GET_PROFIL = "/profil-client";
export const PROFIL_UPDATE = "/profil-client/update";
